import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=04f91a99&scoped=true&"
import script from "./Certifications.vue?vue&type=script&lang=js&"
export * from "./Certifications.vue?vue&type=script&lang=js&"
import style0 from "./Certifications.vue?vue&type=style&index=0&id=04f91a99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f91a99",
  null
  
)

export default component.exports